import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
var DIRECTIONAL_FALLBACKS = {
  Top: ['Vertical', ''],
  Bottom: ['Vertical', ''],
  Vertical: [''],
  Left: ['Horizontal', ''],
  Right: ['Horizontal', ''],
  Horizontal: ['']
};
var DIRECTIONAL_SUFFICES = Object.keys(DIRECTIONAL_FALLBACKS);
export default function getDefaultStyleValue(key, flatStyle) {
  if (key === 'backgroundColor') {
    return 'rgba(0,0,0,0)';
  }

  if (key === 'color' || key.indexOf('Color') !== -1) {
    return 'rgba(0,0,0,1)';
  }

  if (key.indexOf('rotate') === 0 || key.indexOf('skew') === 0) {
    return '0deg';
  }

  if (key === 'opacity' || key.indexOf('scale') === 0) {
    return 1;
  }

  if (key === 'fontSize') {
    return 14;
  }

  if (key.indexOf('margin') === 0 || key.indexOf('padding') === 0) {
    for (var suffix, i = 0; i < DIRECTIONAL_SUFFICES.length; i++) {
      suffix = DIRECTIONAL_SUFFICES[i];

      if (key.substr(-suffix.length) === suffix) {
        var prefix = key.substr(0, key.length - suffix.length);
        var fallbacks = DIRECTIONAL_FALLBACKS[suffix];

        for (var fallback, j = 0; j < fallbacks.length; j++) {
          fallback = prefix + fallbacks[j];

          if (fallback in flatStyle) {
            return flatStyle[fallback];
          }
        }

        break;
      }
    }
  }

  return 0;
}

if (typeof getDefaultStyleValue !== 'undefined' && getDefaultStyleValue && getDefaultStyleValue === Object(getDefaultStyleValue) && Object.isExtensible(getDefaultStyleValue) && !getDefaultStyleValue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(getDefaultStyleValue, '__filemeta', {
    configurable: true,
    value: {
      name: "getDefaultStyleValue",
      filename: "node_modules/react-native-animatable/getDefaultStyleValue.js"
    }
  });
}